import { render, staticRenderFns } from "./BannerCarousel.vue?vue&type=template&id=0715420c&scoped=true&"
import script from "./BannerCarousel.vue?vue&type=script&lang=js&"
export * from "./BannerCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BannerCarousel.vue?vue&type=style&index=0&id=0715420c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0715420c",
  null
  
)

export default component.exports